import React from "react";
import * as PropTypes from "prop-types";
import {formatDateStr, isFunction} from "../../../utils";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow
} from "@mui/material";
import Paper from "@mui/material/Paper";
import {TablePaginationActions} from "../../../components/TablePaginationActions";
import {useTranslation} from "react-i18next";
import {connect} from "react-redux";
import {getCategoryLabel, getOperationLabel} from "../../root/root.utils";


const CompSystemLogTableComponent = ({
                                                 selectedSystemLog,
                                                 props
                                             }) => {
    const {
        rows = [],
        rowClick = (e, row, isAddAction, index) => {
            console.log((e + "," + row + "," + isAddAction + "," + index));
        },
        label = "",
        initialRowsPerPage = 10
    } = props;

    const {t} = useTranslation('translation');

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(initialRowsPerPage);

    if (rows.length === 0) {
        return (<div/>)
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSelectionToggle = (e, row, index) => {
        const isAddAction = !isSelected(row);

        if (isFunction(rowClick)) {
            rowClick(e, row, isAddAction, index)
        }
    }



    const isSelected = (row) => row.id === selectedSystemLog.id;

    return (
        <div className={'CompSystemLogTable-wrapper'}>
            <div className={'CompSystemLogTable-mainTitle'}>{label}</div>
            <TableContainer component={Paper} className={'CompSystemLogTable-container'}>
                <Table className={'CompSystemLogTable-table'} aria-label={label}>
                    <TableHead>
                        <TableRow>
                            <TableCell>{t('system_log.user')}</TableCell>
                            <TableCell>{t('system_log.operation')}</TableCell>
                            <TableCell>{t('system_log.category')}</TableCell>
                            <TableCell>{t('system_log.target_description')}</TableCell>
                            <TableCell>{t('system_log.timestamp')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(rowsPerPage > 0
                                ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                : rows
                        ).map((row, index) => {
                            const isRowSelected = isSelected(row);
                            return (

                                <TableRow
                                    hover
                                    onClick={(e) => handleSelectionToggle(e, row, index)}
                                    role="checkbox"
                                    aria-checked={isRowSelected}
                                    tabIndex={-1}
                                    key={`CompSystemLogTable-row-${row.id}`}
                                    selected={isRowSelected}
                                >
                                    <TableCell component="th" scope="row">
                                        {row.userName}
                                    </TableCell>
                                    <TableCell>{getOperationLabel(row.operation)}</TableCell>
                                    <TableCell>{getCategoryLabel(row.category)}</TableCell>
                                    <TableCell>{row.target_description}</TableCell>
                                    <TableCell>{formatDateStr(row.createdAt)}</TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TablePagination
                                rowsPerPageOptions={[10, 25, 100]}

                                count={rows.length}
                                rowsPerPage={rowsPerPage}
                                labelRowsPerPage={t('components.rows_per_page')}
                                page={page}
                                SelectProps={{
                                    inputProps: {'aria-label': t('components.rows_per_page')},
                                    native: true,
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                            />
                        </TableRow>
                    </TableFooter>
                </Table>
            </TableContainer>
        </div>
    );
}

CompSystemLogTableComponent.propTypes = {
    rows: PropTypes.array,
    rowClick: PropTypes.func,
    label: PropTypes.string,
    multiselect: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => {
    // return state;
    return {
        selectedSystemLog: state.systemLog.selectedSystemLog,
        props: ownProps
    }
}

const CompSystemLogTable = connect(mapStateToProps)(CompSystemLogTableComponent);

export {
    CompSystemLogTable,
}